import { ProductionState } from './types';

export const state: ProductionState = {
	queue: {
		data: [],
		meta: null,
	},
	products: [],
	materials: [],
	plannedMaterials: [],
	plannedMaterialsByProduct: [],
	materialUsage: [],
	materialComparisonByProduct: null,
	suppliers: [],
	productionStages: [],
	users: [],
	timeline: [],
	currentQueueItem: null,
	// Components management
	auxiliaryComponents: [],
	allComponents: [],
	componentFilters: {
		type: 'all',
		category: null,
		isInternal: null,
		supplierId: null,
		search: '',
	},
	activeFilters: {
		status: [],
		priority: null,
		managerId: null,
		placementDate: null,
	},
	// Reports
	reports: {
		efficiency: null,
		timeAnalysis: null,
		costAnalysis: null,
		statusOverview: null,
		loading: false,
		error: null,
	},
	loading: false,
	error: null,
};

export default state;
